<div id="lum-section" data-scroll>
    <div class="container-fluid px-3 px-lg-5">

        <!-- Title -->
        <div class="row justify-content-center">
            <div class="col-12 text-center">
                <h2 class="home-title text-center">The Luminaries Spoke Thus</h2>
                <div class="lum-underline"></div>
            </div>
        </div>

        <!-- Carousel wrapper: arrows + carousel in a symmetric flex row -->
        <div class="lum-carousel-wrapper">

            <!-- LEFT arrow -->
            <button class="lum-arrow" (click)="prev()" aria-label="Previous">&#8249;</button>

            <!-- Carousel fills all space between arrows -->
            <div class="lum-carousel-inner">
                <owl-carousel-o #owlCar [options]="customOptions">
                    <ng-container *ngFor="let slide of testimonial">
                        <ng-template carouselSlide [id]="'lum-' + slide.id">
                            <div class="lum-card-wrap">
                                <div class="lum-card">

                                    <div class="lum-img-wrap">
                                        <img appLazyload [src]="slide.imgUrl" [alt]="slide.name" class="lum-img" />
                                    </div>

                                    <h5 class="lum-name">{{ slide.name }}</h5>
                                    <p class="lum-role">{{ slide.position }}</p>

                                    <div class="lum-sep"></div>

                                    <p class="lum-quote">&#8220;{{ slide.description }}&#8221;</p>

                                </div>
                            </div>
                        </ng-template>
                    </ng-container>
                </owl-carousel-o>
            </div>

            <!-- RIGHT arrow -->
            <button class="lum-arrow" (click)="next()" aria-label="Next">&#8250;</button>

        </div>
    </div>
</div>